/** Thin API layer — prefer acharya-service.js for app use. */
export {
  queryAcharya,
  loadUserProfile,
  loadSacredUserProfile,
  loadJourney,
  loadTattvaForUser,
  loadAcharyaContext,
  fetchAcharyaSuggestions,
  getAcharyaFriendlyError,
  logAcharyaError,
} from "./acharya-service";

import axios from "axios";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";
import { editorHeaders } from "@/lib/sacred-library/sacred-library-api";

import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();

export async function fetchAcharyaDebug(email, question) {
  const params = new URLSearchParams();
  if (email) params.set("email", email);
  if (question) params.set("question", question);
  const q = params.toString() ? `?${params}` : "";
  const res = await axios.get(`${API}/acharya/debug${q}`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}
